import {
  ADVOCATE_RV,
  ARBITRATOR_RV,
  GENERAL_RV,
  SECRETARIAT,
} from "app/constants";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { useDisputes } from "hooks";
import isEmpty from "lodash/isEmpty";
import React, { Fragment, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getDisputesCount } from "slices/disputeSlice";
import useDeepCompareEffect from "use-deep-compare-effect";
import Disputes from "./DisputesRv";

export default function DisputesContainer() {
  const dispatch = useDispatch();
  const history = useHistory();

  const profile = useSelector((state) => state.profile, shallowEqual);
  const user = useSelector((state) => state.user.user);

  let {
    profile: { profile_type },
  } = profile;
  const isRV =
    profile_type === GENERAL_RV ||
    profile_type === ADVOCATE_RV ||
    profile_type === ARBITRATOR_RV;

  let { cases, disputes, respondent, claimant, loading } = useDisputes(isRV);
  const [count, setCount] = useState({ claimant: {}, respondent: {} });
  React.useEffect(() => {
    dispatch(getDisputesCount("rv")).then((res) => {
      setCount(res);
    });
  }, []);

  let childProps = {
    cases,
    disputes,
    profile,
    user,
    respondentDisputes: respondent,
    claimaintDisputes: claimant,
    isRV,
    count,
  };

  useDeepCompareEffect(() => {
    if (
      (!isEmpty(profile) && profile.profile.profile_type === ARBITRATOR_RV) ||
      profile.profile.profile_type === SECRETARIAT
    ) {
      history.push(`/disputes/${profile.profile.profile_type}/active`);
    }
    if (!isEmpty(profile) && profile.profile.profile_type === "sub_admin_rv") {
      history.push(`/subadmin`);
    }
    if (
      !isEmpty(profile) &&
      profile.profile.profile_type === "sub_admin_tiac_rv" &&
      profile.profile.group == "difc"
    ) {
      history.push(`/subadmindifc`);
    }
    if (!isEmpty(profile) && profile.profile.profile_type === "case_manager") {
      history.push(`/casemanager`);
    }
  }, [profile]);

  return (
    <Fragment>
      {!isEmpty(profile) &&
      profile.profile.profile_type !== ARBITRATOR_RV &&
      !loading ? (
        <Disputes {...childProps} />
      ) : (
        <CircularCenteredLoader />
      )}
    </Fragment>
  );

  return;
}
